function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import MagicInputCheckboxBrick from "../bricks/form-input/magic-input-checkbox.brick";
import MagicInputCheckboxesBrick from "../bricks/form-input/magic-input-checkboxes.brick";
import MagicInputCodeBrick from "../bricks/form-input/magic-input-code.brick";
import MagicInputDateBrick from "../bricks/form-input/magic-input-date.brick";
import MagicInputDatetimeBrick from "../bricks/form-input/magic-input-datetime.brick";
import MagicInputFloatBrick from "../bricks/form-input/magic-input-float.brick";
import MagicInputIntegerBrick from "../bricks/form-input/magic-input-integer.brick";
import MagicInputSelectBrick from "../bricks/form-input/magic-input-select.brick";
import MagicInputStringBrick from "../bricks/form-input/magic-input-string.brick";
import MagicInputTimeBrick from "../bricks/form-input/magic-input-time.brick";
import BrickFinder from "zengular/src/brick-finder";
/**
 * @property {Array<Section>} sections
 */

var FormBuilder = /*#__PURE__*/function () {
  function FormBuilder() {
    _classCallCheck(this, FormBuilder);

    this.sections = [];
    this.validators = {};
  }

  _createClass(FormBuilder, [{
    key: "add",
    value: function add() {
      var label = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var finder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var section = new Section(label, finder, this);
      this.sections.push(section);
      return section;
    }
  }]);

  return FormBuilder;
}();
/**
 * @property {FormBuilder} form
 * @property {string} label
 * @property {BrickFinder} finder
 * @property {Array<Input>} inputs
 */


export { FormBuilder as default };

var Section = /*#__PURE__*/function () {
  function Section(label, finder, form) {
    var _this = this;

    _classCallCheck(this, Section);

    this.label = label;
    this.form = form;
    this.finder = finder;
    this.inputs = [];

    this.add.inline = function (field) {
      var input = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var f = _this.add(field, input, attributes);

      f.setInline();
      return f;
    };
  }
  /**
   *
   * @param field
   * @param input
   * @param attributes
   * @returns {Input}
   */


  _createClass(Section, [{
    key: "add",
    value: function add(field) {
      var input = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      input = new Input(field, input, attributes, this);
      this.inputs.push(input);
      return input;
    }
  }]);

  return Section;
}();

var Input = /*#__PURE__*/function () {
  function Input(field, input, attributes, section) {
    _classCallCheck(this, Input);

    this.name = _typeof(field) === "object" ? field.name : field;
    this.input = input === null ? this.deriveInput(field.type) : input;
    this.section = section;
    this.hint = null;
    this.attributes = attributes;
    if (_typeof(field) === 'object' && typeof this.attributes.options === "undefined") this.attributes['options'] = field.options;
    this.inline = false;
  }

  _createClass(Input, [{
    key: "deriveInput",
    value: function deriveInput(type) {
      switch (type) {
        case 'BOOL':
          return MagicInputCheckboxBrick;

        case 'STRING':
          return MagicInputStringBrick;

        case 'INT':
          return MagicInputIntegerBrick;

        case 'ID':
          return MagicInputIntegerBrick;

        case 'FLOAT':
          return MagicInputFloatBrick;

        case 'DATE':
          return MagicInputDateBrick;

        case 'DATETIME':
          return MagicInputDatetimeBrick;

        case 'ENUM':
          return MagicInputSelectBrick;

        case 'SET':
          return MagicInputCheckboxesBrick;

        case 'JSON':
          return MagicInputCodeBrick;

        case 'TIME':
          return MagicInputTimeBrick;

        case 'GUID':
          return MagicInputStringBrick;
      }
    }
  }, {
    key: "setInline",
    value: function setInline() {
      this.inline = true;
      return this;
    }
  }, {
    key: "addValidator",
    value: function addValidator(validator) {
      if (!Array.isArray(this.section.form.validators[this.name])) this.section.form.validators[this.name] = [];
      this.section.form.validators[this.name].push(validator);
      return this;
    }
  }, {
    key: "setHint",
    value: function setHint(hint) {
      this.hint = hint;
      return this;
    }
  }, {
    key: "setAttribute",
    value: function setAttribute(key, value) {
      this.attributes[key] = value;
      return this;
    }
  }]);

  return Input;
}();